<div class="general-container">
  <div *ngIf="loading"
    style="width: 100%; display: flex; justify-content: center">
    <img style="border-radius: 57px;"
      src="assets/icons/logo-fiser-loading.gif" alt=""
      width="150px" />
  </div>

  <div *ngIf="!loading"
    class="container-cards">
    <div
      class="cards"
      (click)="goToQr('/user/pix-pay')">
      <br />
      <span class="title">Cobro con PIX <img height="40px"
          src="assets/icons/wallets/pix.svg"></span><br />
      <span>Generá el código QR y cobrá fácil y
        rápido</span><br /><br /><br />
      <div class="img-cont">
        <img class="arrow_right" src="assets/icons/arrow_right.svg"
          alt="arrow-right" />
      </div>
    </div>
  </div>
</div>
